<div class="card">
    <div class="card-body">
        <div *ngIf="isAdminObservable | async as isAdmin">
            <div *ngIf="isAdmin.value == true">
                <h5 class="card-title">Integration Tester</h5>
                <div class="dx-field">
                    <div class="dx-field-label">Integration</div>
                    <div class="dx-field-value">
                        <ng-container *ngIf="integrationDataSource | async as applicationData">
                            <dx-select-box [dataSource]="applicationData" displayExpr="name" valueExpr="id"
                                (onValueChanged)="onIntegrationValueChanged($event)"></dx-select-box>
                        </ng-container>
                    </div>
                </div>
                <ng-container *ngIf="currentSelectedApplicationId$ | async as selectedIntegration" >
                <div class="dx-field">
                    <div class="dx-field-label">Use login credentials</div>
                    <div class="dx-field-value">
                            <dx-switch style="float: left" [(value)]="usesLoginCredentials"></dx-switch>
                    </div>
                </div>


                <div *ngIf="usesLoginCredentials && selectedIntegration" class="dx-field">
                    <div class="dx-field-label"></div>
                    <div class="dx-field-value">
                        <fieldset>
                            <legend>Login credentials</legend>
                        <div *ngIf="formGroup">
                        <al-link-edit-application-login #fromApp [formGroup]="formGroup" [loginType]="1"
                        [applicationId]="selectedIntegration"
                     [appSide]="'from'" [testerMode]="true" (notifyAccountFound)="setRawLogin($event)">
                        </al-link-edit-application-login>
                    </div>
                </fieldset>
                    </div>
                </div>
                <ng-container *ngIf="applicationLoginsDataSource | async as applogins">
                <div class="dx-field">
                    <div class="dx-field-label">Login select</div>
                    <div class="dx-field-value">
                        <div id="div1" style="width:80%;float:left; padding-right: 20px;">                      <dx-select-box
                            [dataSource]="applogins"
                            placeholder="Select login"
                            [disabled]="usesLoginCredentials"
                            displayExpr="description"
                            valueExpr="id"
                            (onValueChanged)="onLoginChanged($event)"
                          ></dx-select-box></div>
                        <div id="div2" style="float:left"><button [disabled]="usesLoginCredentials" class="btn btn-sm btn-primary add-button" (click)="testAdminLogin()" [disabled]="loadingConnectionTest.value == 'disabled'">
                            <ng-container *ngIf="loadingConnectionTest$ | async as isConnecting">
                            <ng-container *ngIf="isConnecting == 'enabled'">
                            Test login
                            </ng-container>
                            <ng-container *ngIf="isConnecting == 'disabled'">
                            Connecting
                            </ng-container>
                        </ng-container>
                        </button>
                    </div>
                    </div>
                  </div>
                  </ng-container>



                <!-- <div class="dx-field">
                    <div class="dx-field-label">TODO: Select box with customer details to fill in credentials</div>
                    <div class="dx-field-value">
                        <ng-container *ngIf="selectedIntegration | async as applicationData" >
                            <dx-select-box></dx-select-box>
                        </ng-container>
                    </div>
                </div> -->
                <ng-container *ngIf="entityTypeDataSource | async as entityTypeData">
                    <div class="dx-field">
                        <div class="dx-field-label">Entity type</div>
                        <div class="dx-field-value">
                            <dx-select-box [dataSource]="entityTypeData" [searchMode]="'contains'" displayExpr="name" (onValueChanged)="changeSelectedEntity($event)"
                                [searchEnabled]="true" [minSearchLength]="0"></dx-select-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label">Result limit</div>
                        <div class="dx-field-value">
                            <dx-number-box (onValueChanged)="changedResultLimit($event)"></dx-number-box>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label">Raw query (ignored when empty, otherwise overrides setup)</div>
                        <div class="dx-field-value">
                            <dx-text-area
                            [height]="90" (onValueChanged)="updateRawQueryContent($event)"
                          >
                          </dx-text-area>
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label">Filters</div>
                        <div class="dx-field-value">
                            <form [formGroup]="applicationTypeForm">
						<div style="padding-top: 10px;" *ngIf="applicationParams.parameters.length == 0"></div>
                        <ng-container *ngIf="filterOptions$ | async as filterOptions">
						<div *ngFor="let parameter of applicationParams.parameters" class="form-row form-item">
                            <dx-select-box  [formControlName]="parameter.id + '_name'" [items]="objectFields" [searchEnabled]="true" [minSearchLength]="0"  [searchMode]="'contains'" [inputAttr]="{ 'data-lpignore': 'true' }"
                            style="width: calc(40% - 70px); margin-right: 10px;" placeholder="Parameter name"  [(value)]="parameter.name">
                        </dx-select-box>
                        <dx-select-box style="width: calc(30% - 40px);"  [formControlName]="parameter.id + '_type'" displayExpr="displayName"
                            [items]="filterOptions"  [(value)]="parameter.type"></dx-select-box>
							<dx-text-box  [formControlName]="parameter.id + '_defaultValue'"
                            style="width: calc(30% - 30px); margin-left: 10px;" placeholder="Default value"
                            [(value)]="parameter.defaultValue">
                        </dx-text-box>
                        <div [hidden]="applicationParams.parameters.length === 0" (click)="removeParameter(parameter.id)" class="far fa-times text-danger"
                        style="margin-left: 10px; cursor: pointer;"></div>
                    </div>
                </ng-container>
						<button  class="btn btn-sm btn-primary add-button" (click)="addParameter()">Add filter</button>
						<br>

					</form>
                        </div>
                    </div>
                    <ng-container *ngIf="retrievingData$ | async as status">
                    <div class="dx-field">
                        <div class="dx-field-label"></div>
                        <div class="dx-field-value">
                            <button style="float:right" class="btn btn-sm btn-primary add-button" (click)="sendRequest()" [disabled]="status == 'true'">Execute query</button>
                            <button style="float:right; padding-right: 5px" class="btn btn-sm btn-primary add-button" (click)="showJsonComponent()">Show JSON result</button>
                            <ng-container *ngIf="currentSelectedApplicationId.value == 16"><button style="float:right" class="btn btn-sm btn-primary add-button" (click)="getPickList()">PickList</button></ng-container>
                        </div>
                    </div>
                </ng-container>
                    <div *ngIf="queryResultDataSource$ | async as queryResult">
                        <ng-container *ngIf="queryResult.length > 0 || queryResult">
                            <app-shell-pretty-json-viewer #jsoncomponent [json]="queryResult"></app-shell-pretty-json-viewer>
                                <dx-data-grid [dataSource]="queryResult" [showBorders]="true">
                                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                                    <dxo-search-panel [visible]="true"></dxo-search-panel>
                                    <dxo-column-chooser
                                        [enabled]="true"
                                        mode="'select'">
                                    </dxo-column-chooser>
                                </dx-data-grid>
                        </ng-container>
                        </div>

                        <app-shell-pretty-json-viewer #picklistcomponent [json]="picklistSubject.value"></app-shell-pretty-json-viewer>
                </ng-container>
                </ng-container>
            </div>
            <div *ngIf="isAdmin.value == false">
                <h4>No access permitted</h4>
            </div>
        </div>
    </div>
</div>
